module.exports = __webpack_public_path__ + "static/media/Sun.4bb27e51.png";